import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useSite, whatsappLink } from "@/context/SiteContext";

const TONE = {
  "Sent": "text-indigo-300 border-indigo-500/30 bg-indigo-500/10",
  "Viewed": "text-cyan-300 border-cyan-500/30 bg-cyan-500/10",
  "Accepted": "text-emerald-300 border-emerald-500/30 bg-emerald-500/10",
  "Declined": "text-red-300 border-red-500/30 bg-red-500/10",
  "Revised": "text-amber-300 border-amber-500/30 bg-amber-500/10",
  "Draft": "text-white/60 border-white/20 bg-white/5",
};
const tone = (s) => TONE[s] || "text-white/70 border-white/20 bg-white/5";

export default function AccountQuotes() {
  const site = useSite();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/client/quotes").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);

  return (
    <div className="space-y-6" data-testid="account-quotes">
      <div><p className="kicker mb-1">My Ascendia</p><h1 className="font-display text-2xl sm:text-3xl font-semibold text-white">My quotes</h1></div>
      {items === null ? <p className="text-sm text-muted-c">Loading…</p> : items.length === 0 ? (
        <div className="ascendia-card p-10 text-center">
          <FileText className="h-8 w-8 text-gold-soft mx-auto" />
          <p className="mt-4 text-white font-medium">No quotes yet</p>
          <p className="mt-1 text-sm text-muted-c">Start a property assessment and we'll prepare a tailored quote.</p>
          <Link to="/property-intelligence" className="mt-5 inline-flex items-center gap-2 rounded-xl bg-gold px-5 py-2.5 text-sm font-semibold text-black hover:bg-gold-soft">Start assessment <ArrowRight className="h-4 w-4" /></Link>
        </div>
      ) : (
        <div className="space-y-3" data-testid="quotes-list">
          {items.map((q) => (
            <div key={q.id} className="ascendia-card p-5 flex flex-wrap items-center justify-between gap-4">
              <div>
                <div className="flex items-center gap-3"><span className="font-mono text-xs text-gold-soft">{q.ref}</span><span className={`text-[11px] px-2 py-0.5 rounded-full border ${tone(q.status)}`}>{q.status}</span></div>
                <p className="mt-2 text-white font-medium">{q.service || "Custom quote"}</p>
                <p className="text-xs text-muted-c mt-0.5">{q.amount != null ? `From ${q.currency}${q.amount}` : "Amount on quote"} · {(q.updated_at || "").slice(0, 10)}</p>
              </div>
              {q.token ? (
                <a href={`/quote/${q.token}`} target="_blank" rel="noopener noreferrer" data-testid={`view-quote-${q.id}`} className="inline-flex items-center gap-2 rounded-xl bg-gold px-4 py-2.5 text-sm font-semibold text-black hover:bg-gold-soft">View quote <ArrowRight className="h-4 w-4" /></a>
              ) : (
                <a href={whatsappLink(site)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border-subtle)] px-4 py-2.5 text-sm text-white hover:bg-white/5"><MessageCircle className="h-4 w-4 text-[#25D366]" /> Ask a question</a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
